module.exports = __webpack_public_path__ + "static/qs_logo-4b13dc1235f15178e1acfaa73a76b76a.png";